import { Box, Theme } from '@mui/material';
import { SxProps } from '@mui/system';
import { ESignDocumentState } from '../models/ESignDocument';

export const DocumentStatusDot: React.FC<DocumentStatusDotProps> = ({ state, sx = {} }) => {
    let color = '#f2f2f2';

	if (state == 'Completed') color = '#209c05';
	if (state == 'Cancelled') color = '#d32f2f';

    return (
		<Box
			sx={{
				backgroundColor: color,
				borderStyle: 'solid',
				borderWidth: '1px',
				display: 'inline-block',
				height: 10,
				width: 10,
				borderRadius: 180,
				...sx,
			}}
		/>
	);
};

interface DocumentStatusDotProps {
	state?: ESignDocumentState;
	sx?: SxProps<Theme>;
}
